import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'wci-footer',
    standalone: true,
    imports: [RouterLink],
    templateUrl: './footer.component.html',
    styles: [``],
})
export class FooterComponent {}
